<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>   

      <v-col cols="12">
        <v-text-field
          v-model="size"          
          label="Código de Barra"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>  

      <v-btn
        text
        icon
        title="Resetar memória"
        class="my-2"
        @click="resetMemory"
      >
        <v-icon right dark>mdi-close-circle</v-icon>
      </v-btn>    

    </v-row>
  </v-form>
</template>

<script>

import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
      size: 0,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    isEdit: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    BaseUtil: BaseUtil,
  },
  created() {
    // this.entryAttributes = this.setupEntryAttributes(this.entry);
    this.getPackagingsForUnit();
  },
  mounted() {    
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },  
    getPackagingsForUnit: function(hasChanged) {     
      this.packagingsListLoading = true;
      this.$apollo
        .query({
          query: AVAILABLE_PACKAGING_BY_UNIT_QUERY,
          fetchPolicy: "no-cache",          
        })
        .then(response => {
          // console.log("cities", response.data, this.entry);
          this.size = response.data.adminContext.memory.size;                    
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingsListLoading = false));
    },
    resetMemory: function(){
      console.log("click");
      this.packagingsListLoading = true;
      this.$apollo
        .query({
          query: RESET_MEMORY_QUERY,
          fetchPolicy: "no-cache",          
        })
        .then(response => {
          // console.log("cities", response.data, this.entry);
          console.log("reset", response.data.adminContext.resetMemory);
          this.getPackagingsForUnit();
          // this.packagingsListKey++;
          // if (this.entry.unit) {
          //   this.entry.unitId = this.entry.unit.id;
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingsListLoading = false));
    },  
    brandCreated: function(brand) {
      if (brand.brandType == "item") {
        this.extraData.accountGlobalSharedContext.allBrandsOfItems.unshift(brand);
        this.entry.brandId = brand.id;
        this.entry.brand = brand;
      } else {
        this.$refs.util.showErrorMessage("A Marca cadastrada não é do tipo Item, por isso não irá aparecer na lista de marcas!");
      }
    },
    groupCreated: function(group){
      if (group.groupType == "item") {
        this.extraData.accountGlobalSharedContext.allGroupsForFertilizers.unshift(group);
        this.entry.groupId = group.id;
        this.entry.group = group;
      } else {
        this.$refs.util.showErrorMessage("O grupo cadastrado não é do tipo Item, por isso não irá aparecer na lista de grupos!");
      }
    },
    packagingCreated: function(packaging) {
      // if (brand.brandType == "item") {
      this.packagingsList.unshift(packaging);
      this.entry.packagingIds.push(packaging.id);
      // this.entry.brand = brand;
      // } else {
      //   this.$refs.util.showErrorMessage("A Marca cadastrada não é do tipo Item, por isso não irá aparecer na lista de marcas!");
      // }
    },
  }
};
const AVAILABLE_PACKAGING_BY_UNIT_QUERY = gql `
  query {
    adminContext {
      memory
    }
  }
`;

const RESET_MEMORY_QUERY = gql `
  query {
    adminContext {
      resetMemory
    }
  }
`;
</script>

<style scoped></style>
